// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"554":"8d692f31","960":"75fc00ff"}[chunkId] + ".css";
};